import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LostPasswordComponent } from './../../../views/lost-password/lost-password.component';
import { PasswordStrengthWidgetComponent } from './../password-strength-widget/password-strength-widget.component';
import { UserAvitarModalUploadComponent } from './../../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
import { UserPasswordExpiredModalComponent } from '../user-password-expired-modal/user-password-expired-modal.component';
import { HotToastService } from '@ngneat/hot-toast';
import { LoginEnterCodeTFAComponent } from 'src/app/login-enter-code-tfa/login-enter-code-tfa.component';
declare var jQuery:any;
// import { DateTime, Settings } from 'luxon'; // new luxon stuff


@Component({
  selector: 'app-user-details-widget',
  templateUrl: './user-details-widget.component.html',
  styleUrls: ['./user-details-widget.component.css']
})
export class UserDetailsWidgetComponent implements OnChanges {

  
   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full
  user_id: any;
  baseUploadURL: string;
  brandMysql: any;
  user_level: any;
  baseBrandUploadURL: string;
  users: any;
  brand_id: any;
  access_level: any;


  public sparklineData:Array<any> = [34, 43, 43, 35, 44, 32, 44, 52];
  public sparklineData2:Array<any> = [32, 11, 25, 37, 41, 32, 34, 42];
  public sparklineOptions:any = {type: 'line', width: '100%', height: '50', lineColor: '#1ab394', fillColor: "transparent"};

  public peityType1:string = "bar";
  public peityType2:string = "line";
  public peityOptions1:any = { fill: ["#1ab394", "#d7d7d7"], width:100};
  public peityOptions2:any = { fill: ["#1ab394", "#d7d7d7"]};
  public peityOptions3:any = { fill: '#1ab394', stroke:'#169c81'};
  userLogs: any;
  metric_1_data: any;
  count_of_items: number;
  brand_data: any;
  modalRef: BsModalRef;
  bsModalRef: BsModalRef; // for components
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  current_base_route: string;
  metric_qualification_renewal_date: Date;
  brand: any;
  today_format: Date;
  agent_qualification_status_expired: number;
  user_password_expriry_date: any;
  metric_password_date: Date;
  user_password_date_status_expired: number;
  user_password_expiry_date: any;

  // Luxon
  // :: @ https://stackblitz.com/edit/angular-date-pipe-and-luxon?file=app%2Fluxon.component.ts
  // DSTs: DateTime[];
  // notDSTs: DateTime[];
  // DATETIME_HUGE = DateTime.DATETIME_HUGE;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, private toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) { 
    



// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));





            // ... luxon   :: test Area And Dates Setps and establishments.
                      // const DST = 1472688000000; // 2016-09-01T00:00:00Z
                      // const notDST = 1480550400000; // 2016-12-01T00:00:00Z

                      // // DateTime.local().resolvedLocaleOpts();
                      // // { "locale": "en-US", "numberingSystem": "latn", "outputCalendar": "gregory" }

                      // const tz = 'America/Los_Angeles';

                      // Settings.defaultLocale = 'ja';
                      // Settings.defaultZoneName = tz;

                      // this.DSTs = [
                      //   DateTime.fromMillis(DST),

                      //   // 以下2つは同じ
                      //   // DateTime.fromMillis(DST).setLocale('en').setZone(tz),
                      //   DateTime.fromMillis(DST, { locale: 'en', zone: tz, })
                      // ];

                      // // DateTime.locale()以外の場合は、`zone`の設定が必要
                      // this.notDSTs = [
                      //   DateTime.fromMillis(notDST),
                      //   DateTime.fromMillis(notDST, { locale: 'en', zone: tz, })
                      // ];

                      // console.log(DateTime.local().zoneName);
                      // // -> America/Los_Angeles
                      // console.log(DateTime.local(2016, 9, 1).toString());
                      // // -> 2016-09-01T00:00:00.000-07:00

                      // // サマータイム(DST)の確認
                      // ['2016-09-01', '2016-12-01'].forEach(iso => {
                      //   console.log(iso,
                      //     (
                      //       DateTime.fromISO(iso, { zone: tz }).valueOf()
                      //       - DateTime.fromISO(iso).valueOf()
                      //     ) / 60000
                      //   );
                      // })

                      // console.log(
                      //   DateTime.local(2016, 9, 1).valueOf()
                      //   !== DateTime.fromISO('2016-09-01').valueOf()
                      // );
                      // // -> true

                      // console.log(
                      //   DateTime.fromString('5月 25日 1982', 'LLLL dd yyyy').toISO()
                      // );

            // ... end Luxon





  }

 // check for changes. to load data.
 ngOnChanges(changes) {
  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.user_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
   this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing
   this.getUserById(this.user_id);
   this.getLogsCreatedBy(this.user_id);


//  this.openModalWithComponent_User_TFA_setup();


  }
}

getUserById(user_id) {

  this._demoService.getUsersById(user_id).subscribe(
     data => { this.users = data;
      this.brand_id = this.users.map(function(a) {return a ['brand_id']; });
      this.access_level = this.users.map(function(a) {return a ['access_level']; });
      this.user_password_expiry_date = this.users.map(function(a) {return a ['password_expiry_date']; });

      this.getBrand(this.brand_id);
      this.getFormUserLevel(this.access_level);
      this.baseBrandUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing
      // console.log(data);

      // check password expirty
     // agent qualification cheker
console.log('User Password Last Updated Date: ', this.user_password_expiry_date);

// this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date * 1000);
this.metric_password_date = new Date(this.user_password_expiry_date);
console.log('this.metric_password_date: ', this.metric_password_date);
// this.metric_qualification_renewal_date = brand_data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);
// this.openModalWithComponent_PasswordExpired();


// Now checks if a valid date - so if I remove all password dates it will pop up
// Now only checks if the widget is included in the dashboard.
if(this.metric_password_date.toString() === 'Invalid Date' && this.widget_size == 'dashboard') {
  console.log('Invalid date string');
  console.log('Passord has been expired. Date of keys no longer valid.');
  this.user_password_date_status_expired = 1;
  // this.openModalWithComponent_PasswordExpired();
} else {
  console.log('Valid date string');
}


// if (!this.metric_password_date) {
// console.log('Password date invalide mate.')
// }

if (this.metric_password_date <= this.today_format) {
  console.log('NOTICE: This users password has expired');
  // this.user_password_date_status_expired = 1;
  // switched back on july 1st 2025 // to keep in line with security auditing and policy
      /// this.openModalWithComponent_PasswordExpired(); -- WRNONG PASWORD reset -- deactive PERMINATELY JAN 25
}

    },
     err =>{ 
      console.log('API Key has been revoked and not valid or our API is down.');
      // this.user_password_date_status_expired = 1;
      // this.openModalWithComponent_PasswordExpired();
      
      console.error(err)},
     () => console.log(' Loaded.')
   );
}

private getLogsCreatedBy(created_by) {
  this._demoService.fetchSystemLogCreatedBy(created_by).subscribe(
    data => {
      this.userLogs = data;
      let res = data[0];
      // need to do some calcs and return the array for sparkle - TSA Activity Line
      // group items into arrays of days, and then count items for each day,
      // do a total of 30 days and see what it looks like - > max 30 days activity.
      let  count_of_items = Object.keys(this.userLogs).length;
      this.count_of_items = count_of_items;
      // need to get the count of items per particular date ()
      const set_counter_count = 15; // equates to last 15 days a user has activity
      // later include empty days as zeros to display true, in-activity.

      // filter for a day (Need to establish the last date, then do a special function to get (or use today,and get real blanks)

      //  (or get day 1 from last entry... and count back... day -1) in a loop)

      let today = this.gfunc.today;
      this.metric_1_data = this.userLogs.filter((sbi)=>(sbi.service_number === '1'));


      for(let i=0; i < count_of_items; i++) {
        let res2 = this.userLogs[i];
          // filter for a day (Need to establish the last date, then do a special function to get (or use today,and get real blanks)


      } // end loop


      // need to set the user password expirty check.


    },
    err => console.error(err)
  );
} /* */


// private getBrandMysql(brand_id) {
// this._mysqlService.getMysqlBrandDatas(brand_id)
//   .subscribe(
//     res => this.brandMysql = res,
//     err => console.error(err.status)
//   );
// }
 

   // MODAL view a component
   openModalWithComponent_PasswordExpired() {
  //   const initialState = {
  //     title: 'Your Password Has Expired!',
  //     item_id: 1010,
  //     user_id: this.user_id,
  //     size: 'lg',
  //     backdrop: true,
  //     IgnoreBackdropClick: true,
  //     keyboard: false,
  //   };
    
  //   this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, {initialState});
  //   // sets the var to in the component model
  //   this.bsModalRef.content.user_id = this.user_id;
  //  // this.bsModalRef.content.brand_id = this.brand_id;
  //   this.bsModalRef.content.item_id = this.user_id;
  //   this.bsModalRef.content.closeBtnName = 'Logout';
  //   // subscribed to the emitter and get the value.
  //   this.bsModalRef.content.action.take(1).subscribe((value) => {
  // // console.log(value); // here you will get the value of the file
  // // Remove the "uploads/" part from the filename.
  //               // this.filenameselected = value;
  //               // this.stripped = this.filenameselected.replace('uploads/', '');
  //               // // this.model.main_image = this.stripped; // works for simple add not update.
  //               // // console.log(this.stripped);
  //               // // console.log(this.model);
  //               // this.form.photo = this.stripped;
  //               // // this.form.reset();
  //               // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
  //               // this.form.controls['photo'].patchValue(this.form.photo);
  // });


  const config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
  };
  this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, config);
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Logout';
   }




   openModalWithComponent_User_TFA_setup() {
      // const initialState = {
      //   title: 'Your Password Has Expired!',
      //   item_id: 1010,
      //   user_id: this.user_id,
      //   size: 'lg',
      //   backdrop: true,
      //   IgnoreBackdropClick: true,
      //   keyboard: false,
      // };
      
    //   this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, {initialState});
    //   // sets the var to in the component model
    //   this.bsModalRef.content.user_id = this.user_id;
    //  // this.bsModalRef.content.brand_id = this.brand_id;
    //   this.bsModalRef.content.item_id = this.user_id;
    //   this.bsModalRef.content.closeBtnName = 'Logout';
    //   // subscribed to the emitter and get the value.
    //   this.bsModalRef.content.action.take(1).subscribe((value) => {
    // // console.log(value); // here you will get the value of the file
    // // Remove the "uploads/" part from the filename.
    //               // this.filenameselected = value;
    //               // this.stripped = this.filenameselected.replace('uploads/', '');
    //               // // this.model.main_image = this.stripped; // works for simple add not update.
    //               // // console.log(this.stripped);
    //               // // console.log(this.model);
    //               // this.form.photo = this.stripped;
    //               // // this.form.reset();
    //               // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
    //               // this.form.controls['photo'].patchValue(this.form.photo);
    // });
  
  
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.bsModalRef = this.modalService.show(LoginEnterCodeTFAComponent, config);
      // sets the var to in the component model
      this.bsModalRef.content.user_id = this.user_id;
     // this.bsModalRef.content.brand_id = this.brand_id;
      this.bsModalRef.content.item_id = this.user_id;
      this.bsModalRef.content.closeBtnName = 'Logout';
     }





getFormUserLevel(level) {
this._demoService.getUserLevel(level).subscribe(
   data => { this.user_level = data;
    console.log(data);
 },
   err => console.error(err),
   () => console.log('done loading User Levels')
 );
}




addDays(days : number): Date {
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }

  removeDays(days : number): Date {
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }


  
  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand_data = data;

// agent qualification cheker
console.log('Agent Qualification Renewal Date: ', data[0].qualification_renewal_date);

// this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date);
// this.metric_qualification_renewal_date = brand_data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

if (this.metric_qualification_renewal_date <= this.today_format) {
  console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1;
}

      // this.allClientEmailRecipients = data;

    },
     err => console.error(err),
     () => console.log('Brand Loaded.')
   );
  }


   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  




}



/*
import { DatePipe } from '@angular/common'
...
providers: [DatePipe]

'short': equivalent to 'M/d/yy, h:mm a' (6/15/15, 9:03 AM).
'medium': equivalent to 'MMM d, y, h:mm:ss a' (Jun 15, 2015, 9:03:01 AM).
'long': equivalent to 'MMMM d, y, h:mm:ss a z' (June 15, 2015 at 9:03:01 AM GMT+1).
'full': equivalent to 'EEEE, MMMM d, y, h:mm:ss a zzzz' (Monday, June 15, 2015 at 9:03:01 AM GMT+01:00).
'shortDate': equivalent to 'M/d/yy' (6/15/15).
'mediumDate': equivalent to 'MMM d, y' (Jun 15, 2015).
'longDate': equivalent to 'MMMM d, y' (June 15, 2015).
'fullDate': equivalent to 'EEEE, MMMM d, y' (Monday, June 15, 2015).
'shortTime': equivalent to 'h:mm a' (9:03 AM).
'mediumTime': equivalent to 'h:mm:ss a' (9:03:01 AM).
'longTime': equivalent to 'h:mm:ss a z' (9:03:01 AM GMT+1).
'fullTime': equivalent to 'h:mm:ss a zzzz' (9:03:01 AM GMT+01:00).


*/